<template>
  <div class="footer" ref="conright">
    <div class="width">
      <div class="left" style="max-width:1000px">
        <div class="box">
          <div class="name">
            <img src="../assets/images/logo.png" alt="" srcset="" />
            <span>杭州卓智力创信息技术有限公司</span>
          </div>
          <div class="img-box">
            <!-- <img src="../assets/images/wx.png" alt="" srcset="">
							<img src="../assets/images/qq.png" alt="" srcset="">
							<img src="../assets/images/wb.png" alt="" srcset="">
							<img src="../assets/images/icon1.png" alt="" srcset=""> -->
          </div>
        </div>
        <p class="line"></p>
        <div class="box1">
          <div class="tips-left">
            <p class="flex-start">
              <img
                src="../assets/images/address.png"
                alt=""
                srcset=""
                style="width:25px"
              />
              浙江省杭州市余杭区五常街道联创街133号浙江图讯科技大厦1幢5010室
            </p>
            <p class="flex-start">
              <img
                src="../assets/images/email.png"
                alt=""
                srcset=""
                style="width:25px"
              />
              yuyk@cnzzlc.com
            </p>
            <p class="flex-start">
              <img
                src="../assets/images/phone.png"
                alt=""
                srcset=""
                style="width:25px"
              />
              0571-86782875/86782975
            </p>
          </div>
          <div class="tips-right">
            <p class="">
              <span>人才招聘：</span>
              <img src="../assets/images/phone.png" alt="" srcset="" />
              <span>yangww@cnzzlc.com</span>
            </p>
            <p class="">
              <span style="opacity:0">人才招聘：</span>
              <img src="../assets/images/email.png" alt="" srcset="" />
              <span>0571-86782875/86782975</span>
            </p>
          </div>
        </div>
      </div>
      <img src="../assets/images/wx1.png" class="code" alt="" srcset="" />
    </div>
    <p class="time">
      <span>杭州卓智力创信息技术有限公司版权所有</span
      ><span>Copyright © 2017</span
      ><span
        @click="link('https://beian.miit.gov.cn/')"
        style="cursor: pointer;"
        >备案号 浙ICP备2020032026号-2</span
      >
    </p>
    <p style="text-align:center; margin-top:20px;">
      未经授权禁止转载、摘编、复制或建立镜像，如有违反依法追究法律责任
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      imgHeight: 1200,
    };
  },
  mounted() {
    console.log(this.$refs.conright.offsetWidth);
    this.imgHeight = Number(this.$refs.conright.offsetWidth);
  },
  methods: {
    link(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    margin-right: 18px;
  }
}
.footer {
  color: #999999;
  font-size: 16px;
  background: #00061a;
  padding: 50px 0;
  .width {
    overflow: auto;
    .left {
      width: calc(100% - 125px);
      float: left;
      .box {
        height: 44px;
        overflow: hidden;
        .name {
          float: left;
          height: 44px;
          line-height: 44px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            height: 44px;
            width: auto;
            margin-right: 17px;
            padding-left: 16px;
          }
        }
        .img-box {
          float: right;
          height: 36px;
          img {
            float: right;
            width: 35px;
            margin-left: 15px;
          }
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: #006399;
        margin-top: 14px;
        margin-bottom: 20px;
      }
      .box1 {
        p {
          margin-bottom: 10px;
        }
        .tips-left {
          float: left;
        }
        .tips-right {
          float: right;
          p {
            height: 25px;
            line-height: 25px;
            span {
              float: left;
            }
            img {
              height: 25px;
              width: auto;
              float: left;
              margin: 0 10px;
            }
          }
        }
      }
    }
    .code {
      float: right;
      width: 112px;
    }
  }
  .time {
    text-align: center;
    margin-top: 100px;
    span {
      color: #999999;
      margin: 0 20px;
      vertical-align: middle;
    }
  }
}
</style>
